export const url = (value) => {
    try {
        return Boolean(new URL(value));
    }
    catch {
        return false;
    }
};
